/**
 * PATH: packages/email-hub/src/feature/components/email-reader/ReaderRail.tsx
 * FILE_ID: EMAILHUB-EMAILREADER-RAIL-001
 * PURPOSE: Render job context and route rail actions through the controller.
 */
import EmailJobContextRail from '../EmailJobContextRail'
import type { EmailReaderController } from './useEmailReaderController'

export function ReaderRail({
  controller,
  stacked = false,
}: {
  controller: EmailReaderController
  /** Forwarded to the rail: render below the body instead of beside it. */
  stacked?: boolean
}) {
  const {
    email,
    showAISidebar,
    switchEmail,
    onAIAction,
    relatedContextInHeader,
  } = controller
  if (!email || !showAISidebar) return null

  return (
    <EmailJobContextRail
      email={email}
      onJumpTo={switchEmail}
      onAIAction={onAIAction}
      stacked={stacked}
      // Same controller boolean the header reads to grow its chips, so the two
      // surfaces can never disagree about who owns those sections.
      relatedInHeader={relatedContextInHeader}
    />
  )
}
